import { Card, Typography, Statistic, Row, Col, Button, Space } from 'antd';
import {
  FileTextOutlined,
  ClockCircleOutlined,
  CheckCircleOutlined,
  ReloadOutlined,
} from '@ant-design/icons';
import OrderList from 'components/lists/OrderList';
import { useGetToApi } from 'hooks/useApi/useGetAxios';
import { useActionsODT } from 'providers/ActionsOdtProvider';
import React, { useEffect, useMemo, useState } from 'react';

const { Title, Text } = Typography;

const SpecialistOrders = () => {
  let [orders, isLoading, callOrders] = useGetToApi('/order/specialist', {
    initialValues: {
      orders: [],
    },
  });
  const { dowload: dowloadODT } = useActionsODT();
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [currentFilter, setCurrentFilter] = useState(null);

  useEffect(() => {
    callOrders();
  }, [callOrders]);

  orders = useMemo(() => {
    return orders.orders;
  }, [orders.orders]);

  // Aplicar filtro cuando cambien las órdenes o el filtro
  useEffect(() => {
    if (!orders) return;

    let filtered = orders;
    if (currentFilter) {
      filtered = orders.filter((order) => order.stage === currentFilter);
    }

    setFilteredOrders(filtered);
  }, [orders, currentFilter]);

  // Calcular estadísticas
  const stats = useMemo(() => {
    const total = orders?.length || 0;
    const sinIniciar = orders?.filter((order) => order.stage === 'odt_asignada').length || 0;
    const enProceso = orders?.filter((order) => order.stage === 'odt_en_proceso').length || 0;
    const finalizadas = orders?.filter((order) => order.stage === 'finalizada').length || 0;

    return { total, sinIniciar, enProceso, finalizadas };
  }, [orders]);

  // Manejar cambio de filtro
  const handleFilterChange = (filterValue) => {
    setCurrentFilter(filterValue);
  };

  return (
    <div className="min-h-screen bg-gray-50 p-4 md:p-6">
      <div className="max-w-7xl mx-auto space-y-6">
        {/* Header */}
        <Card className="shadow-sm border-0 bg-gradient-to-r from-blue-50 to-blue-100">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between space-y-4 md:space-y-0">
            <div className="flex items-center space-x-3">
              <div className="bg-blue-600 p-2 rounded-lg">
                <FileTextOutlined className="text-white text-lg" />
              </div>
              <div>
                <Title level={3} className="mb-0 text-blue-800">
                  Órdenes de Trabajo
                </Title>
                <Text type="secondary" className="text-blue-600">
                  Gestiona y visualiza todas tus órdenes asignadas
                </Text>
              </div>
            </div>
            <Space>
              <Button
                icon={<ReloadOutlined />}
                onClick={callOrders}
                loading={isLoading}
                className="rounded-lg"
              >
                Actualizar
              </Button>
            </Space>
          </div>
        </Card>

        {/* Estadísticas */}
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} lg={6}>
            <Card className="shadow-sm border-0 text-center">
              <Statistic
                title="Total Órdenes"
                value={stats.total}
                prefix={<FileTextOutlined className="text-blue-500" />}
                valueStyle={{ color: '#1890ff' }}
              />
            </Card>
          </Col>
          <Col xs={24} sm={12} lg={6}>
            <Card className="shadow-sm border-0 text-center">
              <Statistic
                title="Sin Iniciar"
                value={stats.sinIniciar}
                prefix={<ClockCircleOutlined className="text-purple-500" />}
                valueStyle={{ color: '#722ed1' }}
              />
            </Card>
          </Col>
          <Col xs={24} sm={12} lg={6}>
            <Card className="shadow-sm border-0 text-center">
              <Statistic
                title="En Proceso"
                value={stats.enProceso}
                prefix={<ClockCircleOutlined className="text-orange-500" />}
                valueStyle={{ color: '#fa8c16' }}
              />
            </Card>
          </Col>
          <Col xs={24} sm={12} lg={6}>
            <Card className="shadow-sm border-0 text-center">
              <Statistic
                title="Finalizadas"
                value={stats.finalizadas}
                prefix={<CheckCircleOutlined className="text-green-500" />}
                valueStyle={{ color: '#52c41a' }}
              />
            </Card>
          </Col>
        </Row>

        {/* Lista de Órdenes */}
        <OrderList
          orders={filteredOrders.sort((a, b) => new Date(b.id_budget) - new Date(a.id_budget))}
          isLoading={isLoading}
          dowloadODT={dowloadODT}
          onFilterChange={handleFilterChange}
        />
      </div>
    </div>
  );
};

export default SpecialistOrders;
